import "./InDrivePromoCardsStyles.scss";

const CARDS = [
    {
        icon: "/assets/indrive/icon-bono.svg",
        title: (
            <>
                ¡Bono Exclusivo para <em>conductores de InDrive!</em>
            </>
        ),
        text: "Recibe un bono de $2.000.000 para la compra de tu vehículo y hasta $500.000 adicionales para cubrir los gastos de trámite.",
    },
    {
        icon: "/assets/indrive/icon-financiacion.svg",
        title: (
            <>
                ¡Financiamos el 100% <em>de tu auto!</em>
            </>
        ),
        text: "Olvídate de la cuota inicial. Te damos el crédito total para que adquieras tu vehículo sin necesidad de ahorros previos.",
    },
];

export default function InDrivePromoCards() {
    return (
        <div className="indrive_promo_cards">
            {CARDS.map((card) => (
                <div key={card.text} className="indrive_promo_card">
                    <div className="indrive_promo_tag">
                        <img src="/assets/indrive/indrive-logo.png" alt="inDrive" />
                        <span className="indrive_promo_tag_ring" />
                    </div>
                    <img src={card.icon} alt="" className="indrive_promo_icon" />
                    <div>
                        <h3>{card.title}</h3>
                        <p>{card.text}</p>
                    </div>
                </div>
            ))}
        </div>
    );
}
